import { z } from "zod";

export const AttachmentRequirementAllowedKind = {
	Photo: "photo",
	File: "file",
	Any: "any",
} as const;

export const AttachmentRequirementTagDisplaySchema = z.object({
	id: z.string().uuid(),
	name: z.string(),
	description: z.string().nullable().optional(),
	allowedKind: z.string(),
	minimumCount: z.number().int(),
	sortOrder: z.number().int(),
});

export const AttachmentRequirementDisplaySchema = z.object({
	id: z.string().uuid(),
	minimumTotalAttachments: z.number().int(),
	tags: z.array(AttachmentRequirementTagDisplaySchema).default([]),
});

export type AttachmentRequirementTagDisplay = z.infer<
	typeof AttachmentRequirementTagDisplaySchema
>;
export type AttachmentRequirementDisplay = z.infer<
	typeof AttachmentRequirementDisplaySchema
>;

export const EditAttachmentRequirementInfoSchema = z.object({
	minimumTotalAttachments: z.number().int(),
});

export const CreateAttachmentRequirementTagInfoSchema = z.object({
	name: z.string().nullable().optional(),
	description: z.string().nullable().optional(),
	allowedKind: z.string().nullable().optional(),
	minimumCount: z.number().int(),
	sortOrder: z.number().int().nullable().optional(),
});

export const EditAttachmentRequirementTagInfoSchema = z.object({
	name: z.string().nullable().optional(),
	description: z.string().nullable().optional(),
	allowedKind: z.string().nullable().optional(),
	minimumCount: z.number().int(),
	sortOrder: z.number().int(),
});

export type EditAttachmentRequirementInfo = z.infer<
	typeof EditAttachmentRequirementInfoSchema
>;
export type CreateAttachmentRequirementTagInfo = z.infer<
	typeof CreateAttachmentRequirementTagInfoSchema
>;
export type EditAttachmentRequirementTagInfo = z.infer<
	typeof EditAttachmentRequirementTagInfoSchema
>;
